module.exports = __webpack_public_path__ + "static/media/ECI88_eztech.36107563.png";